import { connect } from 'react-redux';

import { setPostalCodeError, clearPostalCodeError, sendLetter } from '../actions/LetterActions';
import { quitApp } from '../actions/GenericActions';

import LetterView from '../components/Steps/Letter/LetterView';

const mapStateToProps = state => ({
  isFetching: state.letter.isFetching,
  letterIsSent: state.letter.letterIsSent,
  postalCodeError: state.letter.postalCodeError,
});

const mapDispatchToProps = dispatch => ({
  sendLetter: postalCode => dispatch(sendLetter(postalCode)),
  quitApp: () => dispatch(quitApp()),
  clearPostalCodeError: () => dispatch(clearPostalCodeError()),
  setPostalCodeError: errorType => dispatch(setPostalCodeError(errorType)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LetterView);
